import { setUserDataToCrisp } from '@/helpers/crisp-helper'

const GOOGLE_AUTH_ERROR_MESSAGES = {
    google_auth_cancelled: 'Google sign-in was cancelled',
    email_already_registered: 'This email is already registered',
    no_account_found: 'No account found for this Google profile',
    google_auth_failed: 'Google authentication failed. Please try again',
}

function getGoogleAuthErrorMessage(code) {
    return GOOGLE_AUTH_ERROR_MESSAGES[code] || GOOGLE_AUTH_ERROR_MESSAGES.google_auth_failed
}

function getAccessToken() {
    return localStorage.getItem('access_token')
}

function setAccessToken(token) {
    return localStorage.setItem('access_token', token)
}

function removeAccessToken() {
    setUserDataToCrisp([
        { key: 'Logged in', value: false },
    ])

    return localStorage.removeItem('access_token')
}

export {
    getAccessToken, setAccessToken, removeAccessToken, getGoogleAuthErrorMessage,
}
